import React from 'react';
import { useTranslation } from 'react-i18next';
import ExpansionStrip from './ExpansionStrip';
import PayoutSelector from './PayoutSelector';
import ReachPanel from './ReachPanel';
import { CurvedEdge, Section, SectionCta, SectionHeading } from './ui';

// WU-REACH: one teal section after "How it works", opening on curve 2 of 3. It replaces "How they get it",
// "Before you pay" and "Where you can send" with three connected parts: reach (where you can send today,
// beside the globe of illustrative routes), delivery (the payout selector) and the expansion strip.
// It keeps the id "where-we-send": the nav, the footer link and HOME_SECTION_IDS point to it.
const GlobalReach: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Section
      id="where-we-send"
      surface="teal"
      aria-label={t('reach.eyebrow')}
      className="reach-section"
      decoration={<CurvedEdge position="top" fill="var(--paper)" />}
    >
      <div className="reach-inner">
        <SectionHeading eyebrow={t('reach.eyebrow')} title={t('reach.title')} subtitle={t('reach.subtitle')} />
        <ReachPanel />
        <h3 className="reach-delivery-title">{t('reach.deliveryTitle')}</h3>
        <PayoutSelector />
        <ExpansionStrip />
        <SectionCta to="download">{t('receive.cta')}</SectionCta>
      </div>
    </Section>
  );
};

export default GlobalReach;
